import React from 'react';

import Profile from '../compObjects/Profile';
import Spinner from '../compUtils/Spinner';

import { useDispatch } from 'react-redux'
import { useObjectSelector, getObject } from '../redux/hooks'


function ProfilesPage(props) {
    
  const dispatch = useDispatch()
  const objectId = "/api/profiles/"
  const profilesSelector = useObjectSelector(objectId)
  const profiles = getObject(objectId, profilesSelector, dispatch)

    return (
        
      <span >
      
      {
        profiles()=== "UNKNOWN"
          ?
          <Spinner />
          :
          <div class="columns is-multiline">
           
           {profiles().map((profile) => (
                  <div class="column ">
                    <Profile profileId={profile.id} />
                  </div>

            ))}
           
          </div>
      }


    </span>
    );
}

export default ProfilesPage;